import StepId from "@/model/progress/StepId";

const providerKey = "hfd_standard*"

export default {
    providerKey,

    routes: [
        {
            name: "hfdPaymentPlanReview",
            path: `/providers/${providerKey}/paymentPlanReview`,
            meta: { step: StepId.PAYMENT_OPTIONS },
            component: () => import("@/views/provider/hfd/HfdPaymentPlanReviewView.vue"),
        },
        {
            name: "hfdAdditionalContactInformation",
            path: `/providers/${providerKey}/additionalContactInformation`,
            meta: { step: StepId.ACCEPT_OFFER },
            component: () => import(/* webpackChunkName: "hfd" */ "@/views/provider/hfd/HfdAdditionalContactInformationView")
        },
        {
            name: "hfdDownpayment",
            path: `/providers/${providerKey}/downpayment`,
            meta: { step: StepId.ACCEPT_OFFER },
            component: () => import(/* webpackChunkName: "hfd" */ "@/views/provider/hfd/HfdDownpaymentCollectionFormView"),
        },
        {
            name: "hfdLoanPayment",
            path: `/providers/${providerKey}/loanPayment`,
            meta: { step: StepId.ACCEPT_OFFER },
            component: () => import(/* webpackChunkName: "hfd" */ "@/views/provider/hfd/HfdLoanpaymentCollectionFormView"),
        },
        {
            path: `/providers/${providerKey}/terms`,
            name: "hfdTerms",
            extends: "terms",
            meta: { step: StepId.ACCEPT_OFFER },
            component: () => import(/* webpackChunkName: "hfd" */ "@/views/provider/hfd/HfdTermsView")
        },
        {
            name: "acceptOfferError",
            path: `/providers/${providerKey}/acceptOfferError`,
            component: () => import(/* webpackChunkName: "hfd" */ "@/views/provider/hfd/HfdTermsView")
        },

        {
            name: "hfdPauseView",
            path: `/providers/${providerKey}/pause`,
            meta: { step: StepId.COMPLETE },
            component: () => import(/* webpackChunkName: "hfd" */ "@/views/provider/hfd/HfdPauseView.vue"),
        },

    ],
}
